import {FormConfiguration} from './form.configuration.model';
import {ThemeConfiguration} from './theme.configuration.model';

export interface SurveyInformation {
    version: number;
    theme: {
        logoId?: string;
        themeId?: number;
        themeName?: string;
        themeConfiguration?: ThemeConfiguration;
        themeVersion?: number;
    };
    configuration: FormConfiguration;
}

/**
 * Informations d'une enquête qui n'en porte encore aucune : l'API renvoie `information` absent sur
 * un brouillon jamais paramétré, alors que l'éditeur a besoin d'un thème et d'une configuration
 * où poser ses modifications.
 */
export const buildEmptySurveyInformation = (): SurveyInformation => ({
    version: 0,
    theme: {},
    configuration: {},
});
